<template>
    <div class="bg">
        <div class="item" v-for="(item,index) in this.player" v-bind:key="index">
                <img src="../../assets/img/head.png">
                <span>{{item.name}}</span>
                <div class="btn-wrap">
                    <label @click="toScreen(index+1,item.playerId)">投屏</label>
                    <label @click="toStart(index+1,item.playerId)">开始评分</label>
                </div>
        </div>
    </div>
</template>

<script>
    import {getVotePlayers,voteStart,votetoScreen} from "@/assets/js/api";

    export default {
        name: "Host",
        data(){
            return{
                player:[
                    // {
                    //     playerId:1,
                    //     name:"选手1",
                    //     hos:"北京协和医院"
                    // },
                    // {
                    //     playerId:2,
                    //     name:"选手2",
                    //     hos:"北京协和医院"
                    // },
                    // {
                    //     playerId:3,
                    //     name:"选手3",
                    //     hos:"北京阜外医院"
                    // },
                    // {
                    //     playerId:4,
                    //     name:"选手4",
                    //     hos:"北京天坛医院"
                    // },
                    // {
                    //     playerId:5,
                    //     name:"选手5",
                    //     hos:"北京广安门医院"
                    // },
                    // {
                    //     playerId:6,
                    //     name:"选手6",
                    //     hos:"北京积水潭医院"
                    // }
                ]
            }
        },
        methods:{
            toScreen(index,playerId) {
                // this.$toast("---开始投屏---"+playerId)
                this.toVoteToScreen(index,playerId)
            },
            toStart(index,playerId){
                // this.$toast("-----开始打分-------"+playerId)
                this.toVoteStart(index,playerId)
            },
            async toGetAllPlayers(){
                const res  =  await getVotePlayers();
                if(res.data.success){
                    this.player = res.data.data
                }
                // console.log(res,"vhost")
            },
            async toVoteStart(index,playerId){
                const res = await voteStart({playerId});
                if(res.data.success){
                   this.$toast(index+"号选手倒计时开始")
                }
            },
            async toVoteToScreen(index,playerId){
                const res = await  votetoScreen({playerId})
                if(res.data.success){
                    this.$toast(index+"号选手投屏成功")
                }
            }

        },
        mounted(){
            this.toGetAllPlayers();
        }

    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background: #FFF url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/qkds/vote_score_bg.jpg") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: row wrap;
    }

    .item{
        /*margin-top: 10px;*/
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: #999 solid 1px;
        box-sizing: border-box;
        justify-content: center;
        img{
            width: 100px;
            height: 100px;
        }
        span{
            font-size: 20px;
            margin: 10px;
        }
        label{
            /*display: block;*/
            font-size: 15px;
            background: #0082C5;
            margin: 0 5px;
            border-radius: 10px;
            padding: 5px 8px;
            color: #FFF;
        }
        .btn-wrap{
            margin-top: 5px;
        }
    }


</style>